import Vue from 'vue'
import Router from 'vue-router'
import login from './components/login.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: () => import('./components/dashboard.vue')
    },
    {
      path: '/vessels',
      name: 'vessel',
      component: () => import('./components/vessel.vue')
    },
    {
      path: '/sizetypes',
      name: 'sizetype',
      component: () => import('./components/sizetype.vue')
    },
    {
      path: '/units',
      name: 'unit',
      component: () => import('./components/unit.vue')
    },
    {
      path: '/states',
      name: 'state',
      component: () => import('./components/state.vue')
    },
    {
      path: '/terminals',
      name: 'terminal',
      component: () => import('./components/terminal.vue')
    },
    {
      path: '/customers',
      name: 'customer',
      component: () => import('./components/customer.vue')
    },
    {
      path: '/importers',
      name: 'importer',
      component: () => import('./components/importer.vue')
    },
    {
      path: '/transports',
      name: 'transport',
      component: () => import('./components/transport.vue')
    },
    {
      path: '/lines',
      name: 'linerdetails',
      component: () => import('./components/line.vue')
    },
    {
      path: '/arrivals',
      name: 'importarrival',
      component: () => import('./components/importarrival.vue')
    },
    {
      path: '/ginpass/:gin_id',
      name: 'gateinpass',
      component: () => import('./components/gateinpass.vue')
    },
    {
      path: '/fclpass/:gout_id',
      name: 'fclpass',
      component: () => import('./components/goutfclpass.vue')
    },
    {
      path: '/destuffpass/:gout_id',
      name: 'destuffpass',
      component: () => import('./components/destuffpass.vue')
    },
    {
      path: '/ecpass/:gout_id',
      name: 'ecpass',
      component: () => import('./components/ecpass.vue')
    },
    {
      path: '/doublepass',
      name: 'doublepass',
      component: () => import('./components/ginpass.vue')
    },
    {
      path: '/igms',
      name: 'igm',
      component: () => import('./components/igm.vue')
    },
    {
      path: '/gateins',
      name: 'gatein',
      component: () => import('./components/gatein.vue')
    },
    {
      path: '/sealbreaking',
      name: 'sealbreakings',
      component: () => import('./components/sealbreaking.vue')
    },
    {
      path: '/fclgateout',
      name: 'fcl',
      component: () => import('./components/fcl.vue')
    },
    {
      path: '/destuffcargo',
      name: 'destuffcargoout',
      component: () => import('./components/destuffcargo.vue')
    },
    {
      path: '/ecgateout',
      name: 'ecgateout',
      component: () => import('./components/ecgateout.vue')
    },
    {
      path: '/loadedinventory',
      name: 'loadedinventory',
      component: () => import('./components/loadedinventory.vue')
    },
    {
      path: '/reports/stock',
      name: 'stockreport',
      component: () => import('./components/stockreport.vue')
    },
    {
      path: '/reports/delivery',
      name: 'deliveryreport',
      component: () => import('./components/deliveryreport.vue')
    },
    {
      path: '/gateinpending',
      name: 'gateinpending',
      component: () => import('./components/gateinpending.vue')
    },
    {
      path: '/igmpending',
      name: 'igmpending',
      component: () => import('./components/igmpending.vue')
    },
    {
      path: '/conthistorylist',
      name: 'conthistorylist',
      component: () => import('./components/conthistorylist.vue')
    },
    {
      path: '/history/:cont_id',
      name: 'history',
      component: () => import('./components/history.vue')
    }
  ]
})